(function ($) {
	'use strict';

	$(function () {
		function highlightMenuItem(id) {
			const inPageJumpTrigger = $('.js-in-page-jump-label');
			const inPageList = $('.js-in-page-list');

			const currentClassName = 'in-page__link--active';

			if ('undefined' !== typeof id && '' !== id) {
				const text = inPageList.find('a[href="#' + id + '"]').text();

				inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
				inPageList.find('a[href="#' + id + '"]').addClass(currentClassName);

				if (text !== '') {
					inPageJumpTrigger.text(text);
				} else {
					inPageJumpTrigger.text('Jump To');
				}
			}
		}

		function registerWaypoints() {
			var $section = $('[data-anchor]');
			var totalHeight = calculateTotalHeight();

			$section.each(function () {
				var id = $(this).attr('id');

				$(this).waypoint({
					handler: function (direction) {
						if ('down' === direction) {
							highlightMenuItem(id);
						}
					},
					offset: totalHeight + 80
				});

				$(this).waypoint({
					handler: function (direction) {
						if ('up' === direction) {
							highlightMenuItem(id);
						}
					},
					offset: function() {
						return -(this.element.clientHeight - totalHeight - 80);
					}
				});
			});
		}

		function scrollToSection(targetId, totalHeight) {
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - totalHeight - 80;
				
				window.scrollTo({
					top: targetPosition,
					behaviour: 'smooth',
				});
			}
		}

		function calculateTotalHeight() {
			const $stickyHeader = $('.js-sticky-header');
			const $inPage = $('.js-in-page');
			
			if (!$inPage.length) {
				return 0;
			}
		  
			const headerHeight = $stickyHeader.outerHeight() || 0;
			const inPageHeight = $inPage.outerHeight() || 0;
			return headerHeight + inPageHeight;
		  }

		function toggleInPageList() {
			const button = document.querySelector('.js-in-page-jump');
			const hider = document.querySelector('.js-in-page-hider');
			const links = document.querySelectorAll('.js-in-page-link');

			button.addEventListener('click', (ev) => {
				ev.preventDefault();
				button.blur();
				hider.classList.toggle('in-page__hider--active');
			});

			links.forEach((link) => {
				link.addEventListener('click', (ev) => {
					ev.preventDefault();
					hider.classList.remove('in-page__hider--active');

					const targetId = link.getAttribute('href').substring(1);
					const totalHeight = calculateTotalHeight();
					scrollToSection(targetId, totalHeight);
				});
			});
		}

		if (document.querySelector('.js-in-page-jump')) {
			registerWaypoints();
			toggleInPageList();
		}
	});
})(jQuery);
